export default __webpack_public_path__ + "assets/webgl/scene-14.58b4d839.glb";